import { FC, HTMLAttributes } from 'react';
import cx from 'classnames';

import { Icon } from 'src/components-v2/DataDisplay';
import { Link } from 'src/components/Inputs';

import { RoundedButtonLink } from '../types';

import styles from './RoundedButton.module.scss';

export type RoundedButtonProps = HTMLAttributes<HTMLAnchorElement> &
  RoundedButtonLink & {
    className?: string;
    fullWidth?: boolean;
  };

export const RoundedButton: FC<RoundedButtonProps> = ({
  className,
  href,
  title,
  fullWidth,
  ...rest
}) => {
  return (
    <Link href={href} {...rest}>
      <a
        className={cx(styles.RoundedButton, className, {
          [styles.fullWidth]: fullWidth,
        })}
        tabIndex={-1}
      >
        {title}
        <Icon
          icon='ArrowRight'
          className={styles.RoundedButton__arrow}
          sx={{ width: 10, height: 10 }}
        />
      </a>
    </Link>
  );
};
